import { Component, OnInit, ViewChild, Input, inject, DestroyRef } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { UpdateBuildComponent } from '../update-build/update-build.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { RouterSegments } from 'src/app/models/router-segments';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { isDate, isReleaseVersion } from '../../../services/util/utils';
import { Constants } from 'src/app/models/constants';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef } from '@angular/core';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { PathToLiveConfiguration } from 'src/app/models/blueprints/path-to-live-configuration';
import { AVAILABLE_STATE_ICON, ENV_PROGRESS_STATUS, ENVIRONMENT_STATUS_ICON, Instance } from 'src/app/models/instance/instance';
import { DeploymentClass } from 'src/app/models/instance-class';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { UpdateBuildPopupComponent } from '../update-build-popup/update-build-popup.component';
import { PackageUpdatePopupComponent } from '../package-update-popup/package-update-popup.component';
import { ExternalPackageDetailsComponent } from '../../external-package/external-package-details/external-package-details.component';
import { Attributes, Datazone, Permissions, Types } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { InstanceType } from 'src/app/models/instance/instance-type';
import { TenantService } from 'src/app/services/api/tenant.service';
import { BaseImageService } from 'src/app/services/api/base-image.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { EnvironmentPages } from 'src/app/models/environment-pages/environment-pages';
import { forkJoin, map, Observable, combineLatest } from 'rxjs';
import { InfraUpgradeComponent } from '../../infra-upgrade/infra-upgrade.component';
import { formatAvailabilityState } from '../../../services/util/utils';
import { ActivityService } from 'src/app/services/api/activity.service';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { handleInstanceMenuPositioning, toUtcString } from 'src/app/services/util/utils';
import { EnvironmentActivityDetails } from '../../environment-details/environment-activity-details/environment-activity-details';
import { DisasterRecoveryService } from 'src/app/services/api/disaster-recovery.service';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';

const REQUIRED_PERMISSIONS =  [
  {
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_NONPII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_PII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-view-instance',
    templateUrl: './view-instance.component.html',
    styleUrls: ['./view-instance.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class ViewInstanceComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);
  toUtcString = toUtcString;
  currentTime: number = Date.now();
  private progressTimer: any;
  Constants = Constants;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  isLinear = false;
  breadcrumbItems: BreadcrumbItem[] = [];
  instances: any;
  solution: any;
  instanceId: string;
  tenantId: string;
  blueprintId: string;
  solutionId: string;
  readonly DeployStatus = DeployStatus;
  RouterSegments = RouterSegments;
  readonly DataZone = DataZone;
  readonly PathToLiveEnvironment = PathToLiveEnvironment;
  readonly InstanceType = InstanceType;
  readonly DeploymentClass = DeploymentClass;
  showSpinner = true;
  isFailed = false;
  displayedColumns: string[] = ['name','dataZone', 'version', 'releaseVersion', 'status', 'build'];
  transientColumns: string[] = ['name','dataZone', 'version', 'rvtStatus', 'action', 'menu'];
  dataSource: any;
  transientDataSource: any;
  sortInfo: any;
  paginationSize = 10;
  pageIndex = 0;
  currentStep = 0;
  runTest: any;
  viewTransient: boolean;
  formData: any;
  transientEnvironmentComponent: boolean;
  transientInstanceBuildVersion: any;
  transientInstanceStatus: any;
  transientInstanceName: any;
  transientInstanceEnv: any;
  deployed: boolean;
  configured: boolean;
  updated: boolean;
  tested: boolean;
  configResponse: any;
  testResponse: any;
  configurationId: any;
  status: any;
  failedStatus: DeployStatus[] = [];
  inProgressStatus: DeployStatus[] = [];
  updatedStatus: DeployStatus[] = [];
  pendingStatus: DeployStatus[] = [];
  isLoading: boolean;
  searchText: any;
  configResponseValue: any;
  testResponseValue: any;
  configResponsePagination: any;
  testResponsePagination: any;
  count: any;
  countCU: number = 0;
  defaultState: boolean;
  solutionVersionInfo: any;
  blueprint: any;
  pathToLiveInstances: any;
  devInstance: any;
  otherInstance: any;
  piiNonPTLInstances: any;
  nonPiiNonPTLInstances: any;
  testDataZoneInstances: any[];
  piiDataZoneInstances: any[];
  classEInstances: any;
  isLive: boolean;
  customPackage: any;
  isInsSelectionLoaded: boolean;
  instanceUpdatePermission: boolean;
  clientName: any;
  isAWS: boolean;
  isRefreshing: boolean = false;
  drInProgress$: Observable<boolean>;
  isDREnabled$: Observable<boolean>;
  showDRBanner$: Observable<boolean>;
  formatAvailabilityState = formatAvailabilityState;
  statusIcons = {
    deployed: 'check_circle_filled',
    configured: 'check_circle',
    initialized: 'check_circle',
    updated: 'check_circle',
    tested: 'check_circle',
    failed: 'cancel_filled',
    configuration_failed: 'cancel_filled',
    terminated: 'error_outline',
    termination_failed: 'cancel_filled',
    test_failed: 'cancel_filled',
    update_failed: 'cancel_filled',
    stopped: 'error_outline',
    start_failed: 'cancel_filled',
    stop_failed: 'cancel_filled',
    initialize_failed: 'cancel_filled',
    deploying: 'change_circle',
    terminating: 'change_circle',
    configuring: 'change_circle',
    updating: 'change_circle',
    initializing: 'change_circle',
    operation_inprogress: 'change_circle',
    inprogress: 'change_circle',
    stopping: 'change_circle',
    stopping_agent: 'change_circle',
    starting: 'change_circle',
    starting_agent: 'change_circle',
    testing: 'change_circle',
    fallback_inprogress: 'change_circle',
    failover_inprogress: 'change_circle',
  };

  readonly INSTANCE_DEPLOYING_STATES_COUNT = [
    DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.CONFIGURING,
    DeployStatus.UPDATING, DeployStatus.INITIALIZED, DeployStatus.FAILOVER_APPLYING,
    DeployStatus.FAILBACK_APPLYING, DeployStatus.PRE_FAILBACK_APPLYING,
    DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING
  ];

  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED];
  showComponentUpdate: boolean;
  readonly WARNING_STATUS =[DeployStatus.FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.TEST_FAILED];
  hideOldView = true;
  availableStateIcon = AVAILABLE_STATE_ICON;
  hoveredInstance: any = null;
  readonly UPDATE_ALLOWED_STATUS = [DeployStatus.FAILED, DeployStatus.UPDATED, DeployStatus.DEPLOYED, DeployStatus.CONFIGURING, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.TEST_FAILED, DeployStatus.TESTED, DeployStatus.UPDATE_FAILED, DeployStatus.STOP_FAILED];
  environmentStatusIcon = ENVIRONMENT_STATUS_ICON;
  envProgressStatus = ENV_PROGRESS_STATUS;

  constructor(private sidenavService: SidenavService, private toastrService: CustomToastrService,
    private instanceService: InstancesService, private router: Router, private authService: AuthService,
    private solutionsService: SolutionsService,
    public dateTimeFormatService: DateTimeFormatService, public activatedRoute: ActivatedRoute,
    private dialog: MatDialog, private toastrErrorService: ToastrErrorService, private _formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private blueprintsService: BlueprintsService, private errorPageService: ErrorPageService, private tenantService: TenantService,
    public solutionVersionsService: SolutionVersionsService, private permissionsService: PermissionsService,
    private baseImageService: BaseImageService, private activityService: ActivityService, public activityProgressService: ActivityProgressService, private disasterRecoveryService: DisasterRecoveryService,
    private featureFlagsManagerService: FeatureFlagsManagerService) {
      this.drInProgress$ = this.disasterRecoveryService.drInProgress$;
      this.isDREnabled$ = this.disasterRecoveryService.isDREnabled$;

   }

  ngOnInit(): void {
    this.showDRBanner$ = combineLatest([this.drInProgress$, this.isDREnabled$]).pipe(
      map(([drInProgress, isDREnabled]) => drInProgress === true && isDREnabled === true)
    );
    this.clientName = this.router.url.split('.')[0].split('/')[3];
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.CONTINUOUS_UPDATE';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.BLUEPRINT_READ]) {
      this.router.navigate(['/', this.tenantId, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.instanceStatus();
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.isInsSelectionLoaded = false;
    this.getBlueprint();
    this.isLoading = true;
    this.instanceUpdatePermission = this.permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] || this.permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII] || this.permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE] ? true : false;
    this.progressTimer = setInterval(() => { this.currentTime = Date.now(); }, 1000);
  }

  ngOnDestroy(): void {
    if (this.progressTimer) { clearInterval(this.progressTimer); }
  }

  ngAfterViewChecked(){
    this.cdr.detectChanges();
 }

  /**
   * Categorized instance status
   */
  instanceStatus(): void {
    this.failedStatus = [
      DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.INITIALIZE_FAILED,
      DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.TERMINATED, DeployStatus.POST_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED,DeployStatus.STOP_FAILED,DeployStatus.STOPPED, DeployStatus.TEST_FAILED
    ];
    this.updatedStatus = [
      DeployStatus.UPDATED, DeployStatus.DEPLOYED, DeployStatus.TESTED, DeployStatus.INITIALIZED
    ];
    this.pendingStatus = [
      DeployStatus.CONFIGURING, DeployStatus.CONFIGURED, DeployStatus.TERMINATING
    ];
    this.inProgressStatus = [
      DeployStatus.DEPLOYING, DeployStatus.INITIALIZING, DeployStatus.UPDATING, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.FAILOVER_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.INPROGRESS, DeployStatus.TESTING,
      DeployStatus.CONFIGURING
    ];
  }

  canAccessBaseImageFeature(instanceId?: string): boolean {
    if (!instanceId) {
      return false;
    }

    // Load and store flags if not already stored
    this.featureFlagsManagerService.loadAndStoreInstanceFeatureFlags(instanceId);

    // Check if BASE_IMAGE_UPDATE is enabled for this instance
    const isEnabled = this.featureFlagsManagerService.isInstanceFeatureEnabled(instanceId, FeatureFlags.BASE_IMAGE_UPDATE);
    return isEnabled;
  }

  refreshTransientInstance(): void {
    this.isLoading = true;
    this.isLoading = false;

    this.count = this.count !== 1 ? 1 : 0;
    this.defaultState = true;
    this.defaultState = false;
  }

  getBlueprint(): void {
    this.blueprintsService.getBlueprints()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(blueprints => {
      this.blueprint = blueprints.find(item => item.id === this.blueprintId);
      this.solutionId = this.blueprint.solutionId;
      this.breadcrumbItems.push(
        {icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
        {label: translate('TENANT_CONTINUOUS_UPDATE.CONTINUOUS_UPDATE'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE]},
        {label: this.blueprint.name}
      )
      this.getInstance();
    }, (error) => {
      this.errorPageService.show404Page()
    });
  }

  /**
   * Get all the instance
   */
  getInstance(): void {
    if(!this.instances) {
      this.showSpinner = true;
    }
    const instanceObj: any = {
      tenantId: this.tenantId,
      blueprintId: this.blueprintId
    };
    this.getSolutionById(this.solutionId);
    this.instanceService.getInstances(instanceObj)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
      if (response?.total > 10) {
        instanceObj.size = response?.total;
        this.instanceService.getInstances(instanceObj)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          this.setData(result);
        })
      } else {
        this.setData(response);
      }
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.showSpinner = false;
      this.isFailed = true;
    });
  }

  setData(result) {
    this.isInsSelectionLoaded = true;
    this.classEInstances = result.data.filter((item: any) => item.deploymentClass === DeploymentClass.E);
    this.instances = result.data.filter(item => item.status !== DeployStatus.TERMINATED && item.status !== DeployStatus.TERMINATING && item.status !== DeployStatus.TERMINATION_FAILED && item.deploymentClass !== DeploymentClass.E);
    this.devInstance = this.getDevInstance(this.instances);
    this.otherInstance = this.instances.filter(i => i.type === InstanceType.OTHER || i.type === InstanceType.EAAS);
    const otherInstances = this.getOtherInstancesByDataZone(this.instances);
    this.nonPiiNonPTLInstances = otherInstances.nonPii
    this.piiNonPTLInstances = otherInstances.pii;
    this.isLive = this.resolveLiveStatus(this.instances);
    this.setPTLInstances(this.instances);
    this.instances.forEach(item => {
      this.solutionsService.getSolutionVersion(item.solutionId, item.solutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(version => {
        item.version = version.version;
        item.releaseVersion = version.releaseVersion;
        const [currentMajor, currentMinor, currentPatch] = item.version?.split('.').map(Number);
        let [major, minor, patch] = [0, 0, 0];
        if (version.minCompatibleProductVersion) {
          [major, minor, patch] = version.minCompatibleProductVersion.split('.').map(Number);
        }
        const isInfraUpgrade =
          major <= currentMajor &&
          minor <= currentMinor &&
          patch <= currentPatch;
        item.isInfraUpgrade = version.minCompatibleProductVersion && isInfraUpgrade;
        this.loadData(this.instances);
      },
      (error) => {
        this.isInsSelectionLoaded = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });

      if (item.packageReferenceId) {
        this.solutionsService.getReferencePackagesById(item.solutionId, item.packageReferenceId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            item.externalPackage = data;
          },
          (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
      }
    });

    this.classEInstances.forEach((item: any) => {
      this.solutionsService.getSolutionVersion(item.solutionId, item.solutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(version => {
        item.version = version.version;
        item.releaseVersion = version.releaseVersion;
        const [currentMajor, currentMinor, currentPatch] = item.version?.split('.').map(Number);
        let [major, minor, patch] = [0, 0, 0];
        if (version.minCompatibleProductVersion) {
          [major, minor, patch] = version.minCompatibleProductVersion.split('.').map(Number);
        }
        const isInfraUpgrade =
          major <= currentMajor &&
          minor <= currentMinor &&
          patch <= currentPatch;
        item.isInfraUpgrade = version.minCompatibleProductVersion && isInfraUpgrade;
        // item.isInfraUpgrade =  isReleaseVersion(item.version);
        this.loadData(this.classEInstances);
      },
      (error) => {
        this.isInsSelectionLoaded = true;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    });
    this.showSpinner = false;
    this.loadInstanceActivity(this.instances);
  }

  private setPTLInstances(instances: Instance[]): void {
    if (this.blueprint?.pathToLiveConfiguration) {
      const instancesMap = instances
        .reduce((acc, instance) => {
          acc[instance.id] = instance;
          return acc;
        }, {});


      this.pathToLiveInstances = this.blueprint.pathToLiveConfiguration.map((pathToLiveConfiguration, index, pathToLiveArray) => {
        let instance;
        if (pathToLiveConfiguration.instanceId && instancesMap[pathToLiveConfiguration.instanceId]) {
          instance = instancesMap[pathToLiveConfiguration.instanceId];
          instance.environment = pathToLiveConfiguration.environment;
          if(instance.environment === PathToLiveEnvironment.PREPROD && (instance.status !== DeployStatus.TERMINATED && instance.status !== DeployStatus.TERMINATION_FAILED && instance.status !== DeployStatus.TERMINATING)) {
            this.showComponentUpdate = true;
          }
        } else {
          instance = this.buildInstancePlaceholder(pathToLiveConfiguration);
        }

        return instance;
      });
      this.filterPathToLiveInstances();
    }
  }

  private buildInstancePlaceholder(pathToLiveConfiguration: PathToLiveConfiguration): any {
    return {
      name: `${pathToLiveConfiguration.environment}_${translate('BLUEPRINT_SUMMARY.NA')}`,
      environment: pathToLiveConfiguration.environment,
      instanceClass: pathToLiveConfiguration.deploymentClass,
      dataZone: pathToLiveConfiguration.dataZone,
      status: DeployStatus.NOT_DEPLOYED
    };
  }

  private getDevInstance(allInstances: any): Instance {
    return allInstances.filter(i => i.deploymentClass === DeploymentClass.D && i.type === Types.DEV);
  }

  private getOtherInstancesByDataZone(instances: any[]): { pii: Instance[], nonPii: Instance[] } {
    return {
    pii: instances.filter(i => i.type === InstanceType.OTHER && i.dataZone === DataZone.SECURE),
    nonPii: instances.filter(i => i.type === InstanceType.OTHER && i.dataZone === DataZone.DEVELOPMENT)
  };
}

  private filterPathToLiveInstances(): void {
    if(this.pathToLiveInstances?.length > 0) {
    this.testDataZoneInstances = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.DEVELOPMENT]));
    this.piiDataZoneInstances = this.pathToLiveInstances.filter(this.filterInstanceByDataZone([DataZone.SECURE, DataZone.LIVE]));
  } else {
    this.testDataZoneInstances = this.instances?.filter(i => i.deploymentClass === DeploymentClass.C && (i.type !== InstanceType.OTHER && i.type !== InstanceType.EAAS));
    this.piiDataZoneInstances = this.instances?.filter(i => (i.deploymentClass === DeploymentClass.B || i.deploymentClass === DeploymentClass.A) && (i.type !== InstanceType.OTHER && i.type !== InstanceType.EAAS));
  }
}

  private resolveLiveStatus(instances: Instance[]): boolean {
    const live = instances.find(instance => instance.deploymentClass === DeploymentClass.A);
    return this.INSTANCE_DEPLOYED_STATES.includes(live?.status);
  }

  filterInstanceByDataZone(dataZones: DataZone[]): (instance: any) => boolean {
    return (instance): boolean => dataZones.includes(instance.dataZone) && instance?.id;
  }

  /**
   * Get the solution by id
   * @param solutionId - the id of the target solution
   */
  getSolutionById(solutionId): void {
    this.solutionsService.getSolutionById(solutionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      this.solution = result;
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }


  getSolutionVersionDetails(): void {
    this.solutionsService.getSolutionVersion(this.solutionId, this.solution.targetSolutionVersionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
      this.solutionVersionInfo = data;
    },
    (error) => {
      this.toastrService.clear();
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  /**
   * Navigate to Continuous updates page
   * @param instance - container of blueprintId and instanceId
   */
  openInstanceDetails(instance): void {
    this.router.navigate(['/', this.authService.principal.provider,
    RouterSegments.TENANT,
    this.tenantId,
    RouterSegments.BLUEPRINTS,
    this.blueprint.id,
    RouterSegments.ENVIRONMENT,
    instance.id,
    ], {
    queryParams: { fromCU: true }
  });
  }

  /**
   * Update the build for the instance
   * @param data - contains solution, change task and build versions to be displayed on update build page
   */
  updateBuild(data): void {
    if(this.WARNING_STATUS.includes(data.status)){
      forkJoin({showWarning: this.getInstaceActivity(data.id)}).subscribe(({ showWarning }) => {
        data.showWarningPopup = showWarning;
      });
    }
    if (data?.status !== DeployStatus.UPDATING && this.instanceUpdatePermission) {
      data.solution = this.solution;
      data.taskSolutionVersion = this.solutionVersionInfo;
      data.blueprint = this.blueprint;
      data.preprodData = this.instances?.find((e) => e.environment === PathToLiveEnvironment.PREPROD);
      data.isAWS = this.isAWS;
      this.sidenavService.openInRightSidenav(UpdateBuildPopupComponent, {data})
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (!formData) {
          return;
        }
        if(formData.externalSelected) {
          this.customPackage = data.packageReferenceId;
        } else {
          this.customPackage = undefined;
        }
        const versionForm: any = {
          id: data.id,
          targetSolutionVersionId: formData.dataselectedVersionId,
          packageReferenceId: this.customPackage
        };

        if (formData?.sizingDocumentId) {
          versionForm.sizingDocumentId = formData.sizingDocumentId;
        }
        this.instanceService.putBuildVersion(versionForm)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(reposnse => {
        this.getInstance();
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.UPDATE_BUILD.ENV_MSG_TITLE');
              const message = translate('INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_BUILD_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
        },
        (error) => {
        const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.UPDATE_BUILD_FAILED'),
                      description: errorMessage
                    }
              });
        });
      });
    } else {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    }
  }

  componentUpdate(instance): void {
    localStorage.removeItem("preprodData");
    if (instance.environment === PathToLiveEnvironment.LIVE) {
       const preprodData = this.instances?.find((e) => e.environment === PathToLiveEnvironment.PREPROD);
       localStorage.setItem("preprodData",JSON.stringify(preprodData))
    }
    if (instance?.status !== DeployStatus.UPDATING && this.instanceUpdatePermission) {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
        this.solutionId, instance.blueprintId, RouterSegments.INSTANCE, instance.id, RouterSegments.COMPONENT_UPDATE]);
    }
  }

  baseImageUpdate(instance): void {
    this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.UPDATE_BUILD.BASE_IMG_TITLE'),
          message: translate('INSTANCE_DETAILS.UPDATE_BUILD.BASE_IMG_MESSAGE'),
          note: translate('INSTANCE_DETAILS.UPDATE_BUILD.BASE_IMG_NOTE'),
          confirmButtonText: translate('DIALOG.CONFIRM'),
          page: 'baseImage'
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (!confirm) { return; }
          this.baseImageService.createBaseImageUpdate(instance.id, {})
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: () => {
                this.router.navigate(
                  ['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId,
                    RouterSegments.BLUEPRINTS, instance.blueprintId, RouterSegments.ENVIRONMENT, instance.id],
                  { state: { data: EnvironmentPages.BASE_IMAGE } }
                );
              },
              error: (error) => {
                setTimeout(() => {
                  const title = translate('ERRORS.SERVICE_AVAILABILITY');
                  const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
                  this.toastrService.errMessage(message, title);
                }, 500);
              }
            });
        })
  }

  packageUpdate(instance): void {
    if(this.WARNING_STATUS.includes(instance.status)){
      forkJoin({showWarning: this.getInstaceActivity(instance.id)}).subscribe(({ showWarning }) => {
        instance.showWarningPopup = showWarning;
      });
    }
    if (instance.environment === PathToLiveEnvironment.LIVE) {
       const preprodData = this.instances?.find((e) => e.environment === PathToLiveEnvironment.PREPROD);
       instance.preprodData = preprodData.packageReferenceId;
    }
    if (instance?.status !== DeployStatus.UPDATING && this.instanceUpdatePermission) {
      const data = {
        instance
      };
      this.sidenavService.openInRightSidenav(PackageUpdatePopupComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (!data) {
          return;
        }
        const versionForm = {
          id: instance.id,
          packageReferenceId: data.id,
          targetSolutionVersionId: instance.solutionVersionId,
        };

        this.instanceService.putBuildVersion(versionForm)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(reposnse => {
          this.getInstance();
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.UPDATE_BUILD.ENV_MSG_TITLE');
              const message = translate('INSTANCE_DETAILS.PACKAGE_UPDATE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
        },
        (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.UPDATE_BUILD_FAILED'),
                      description: errorMessage
                    }
              });
        });
      });
    } else {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    }
  }

  /**
   * Retry the build
   * @param data - information to be displayed on confirmation dialog
   */
  retryBuild(data): void {
    if (this.instanceUpdatePermission) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.UPDATE_BUILD.TITLE'),
          message: translate('INSTANCE_DETAILS.UPDATE_BUILD.MESSAGE') + data.version,
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            const versionForm = {
              id: data.id,
              targetSolutionVersionId: data.versionId
            };
            this.instanceService.putBuildVersion(versionForm)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(reposnse => {
            this.getInstance();
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.UPDATE_BUILD.ENV_MSG_TITLE');
              const message = translate('INSTANCE_DETAILS.RETRY_UPDATE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.UPDATE_BUILD_FAILED'),
                      description: errorMessage
                    }
              });
          });
          }
        });
    } else {
      this.dialog.open(GenericErrorComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    }

  }

  /**
   * Display the instance
   * @param data - instnce data
   */
  loadData(data?): void {
    this.isLoading = false;
    //this.pageIndex = 0;
    if (this.sortInfo) {
      const sortedData = this.sortInstanceData(this.sortInfo);
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      this.dataSource = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    }
    this.searchResultsConfig();
    this.searchResultsTest();
  }

  /**
   * Breadcrumbs of views instance page
   */
  breadcrumbs(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.CONTINUOUS_UPGRADE')},
      {label: translate('LEFT_SIDE_NAV.SOLUTIONS'), url: ['updates-solution']},
      {label: (this.solution?.name ? this.solution?.name : '') + ' - ' + translate('LEFT_SIDE_NAV.VIEW_TENANTS'),
      url: [RouterSegments.SOLUTIONS, this.solutionId]},
      {label: this.tenantId});
  }

  /**
   * Sort the instance
   * @param event - the specific event
   */
  sortData(event): void {
    this.sortInfo = event;
    // this.showPagination = false;
    setTimeout(() => {
      // this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.instances = this.sortInstanceData(event);
    this.dataSource = new MatTableDataSource(this.instances?.slice(this.pageIndex, this.paginationSize));
  }

  /**
   * Sort the instance
   * @param event - sord data based on event
   * @returns - the data in ascending or descending order
   */
  sortInstanceData(event): any {
    return this.instances?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'name':
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
        case 'dataZone':
          comparatorResult = a?.datazone && b?.datazone ? a?.datazone?.localeCompare(b?.datazone) : !a?.datazone ? -1 : 1;
          break;
        case 'version':
          comparatorResult = a?.version && b?.version ? a?.version?.localeCompare(b?.version)
            : !a?.version ? -1 : 1;
          break;
        case 'status':
          comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status)
            : !a?.status ? -1 : 1;
          break;
        default:
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) :
           !a?.name ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  /**
   * Navigate to Continuous update page
   */
  goToTenant(): void {
    if(this.transientEnvironmentComponent) {
      this.transientEnvironmentComponent = false;
    } else {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE]);
    }
  }


  /**
   * Makes a search when a user search for particular result in config/test results.
   */
  searchResultsConfig(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }
    if (this.searchText) {
      this.configResponse = this.configResponseValue.filter(item => item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.configResponse = this.configResponseValue;
    }
  }

  searchResultsTest(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }
    if (this.searchText) {
      this.testResponse = this.testResponseValue.filter(item => item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.testResponse = this.testResponseValue;
    }

  }


  /**
   * Pagination for the view instance
   * @param event - event of the pagination
   */
  pageChangedConfig(event): any {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
    const firstIndex = this.pageIndex * this.paginationSize;
    this.configResponsePagination =
    this.configResponse.slice(firstIndex, firstIndex + this.paginationSize);
  }

  /**
   * Pagination for the view instance
   * @param event - event of the pagination
   */
  pageChangedTest(event): any {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
    const firstIndex = this.pageIndex * this.paginationSize;
    this.testResponsePagination =
    this.testResponse.slice(firstIndex, firstIndex + this.paginationSize);
  }


  customPackageClick(instance): void {
    const data = {
      externalPackage: instance.externalPackage,
      dataLoaded: true,
      instance
    }
    this.dialog.open(ExternalPackageDetailsComponent, {
      height: '85vh',
      width: '50vw',
      autoFocus: false,
      panelClass: 'custom-pack-dialog',
      data
    });
  }

/**
 *
 * @param instanceId
 * @returns true if the instance has a latest failed config activity.
 */
getInstaceActivity(instanceId): Observable<boolean> {
  return this.activityService.getInstanceActivityLogs(instanceId).pipe(takeUntilDestroyed(this.destroyRef),
    map(data => {
      if (!data?.length) {
        return false;
      }
      const latestAction = data.filter(log => log?.status === 'failed' && log?.action === 'config').sort((a, b) =>
        new Date(b?.startTime).getTime() -new Date(a?.startTime).getTime())[0];
      return !!latestAction;
    })
  );
}
/**
 * Opens the Infra Upgrade dialog for the selected instance and reloads the instance data upon closure of dialog.
 *
 * @param instance - The selected instance for which the upgrade dialog should be opened.
 */
infraUpgradeClick(instance: Instance): void {
   localStorage.removeItem("preprodInfraData");
    if (instance.environment === PathToLiveEnvironment.LIVE) {
       const preprodData = this.instances?.find((e) => e.environment === PathToLiveEnvironment.PREPROD);
       localStorage.setItem("preprodInfraData",JSON.stringify(preprodData))
    }
  const data = {
    dataLoaded: true,
    instance
  }
  this.dialog.open(InfraUpgradeComponent, {
    height: '85vh',
    width: '50vw',
    autoFocus: false,
    panelClass: 'infra-upgrade-dialog',
    data
  })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(version => {
      if (version) {
              const payload = {
                id: instance.id,
                solutionVersion: version

              }
              this.instanceService.updateInfraVersion(payload)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(response => {
                  this.showSpinner = true;
                  this.isLoading = true;
                  this.isInsSelectionLoaded = false;
                  this.getInstance();
                  setTimeout(() => {
                    const message = translate('INSTANCE_DETAILS.SOLUTION_VERSION_INFRA',{version});
                    const title = translate('INSTANCE_DETAILS.INFRA_UPGRADE_SUCCESS');
                    this.toastrService.successMessage(message, title);
                  }, 500)
                }, (error) => {
                  const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
                  this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.INFRA_UPGRADE_FAILED'),
                      description: errorMessage
                    }
                  });
                })
      }
    });
  }


    refreshClick(): void {
    this.isRefreshing = true;
    this.isRefreshing = false;
    this.countCU = this.countCU !== 1 ? 1 : 0;
    this.getInstance();
    }
  
  // Set hovered instance on mouse over
  mouseOver(data): void {
   this.hoveredInstance = data.id ?? data.name;
  }

  // Clear hovered instance on mouse out
  mouseOut(data): void {
    this.hoveredInstance = null;
  }
  // Check read permission based on data zone
  hasReadPermission(data) {
    return ((data?.dataZone === DataZone.DEVELOPMENT && this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]) 
    || (data?.dataZone === DataZone.SECURE && this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) 
    || (data?.dataZone === DataZone.LIVE && this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE]));
  }
  // Check update permission based on data zone
  hasUpdatePermission(data) {
    return ((data?.dataZone === DataZone.DEVELOPMENT && this.permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII] && this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII])
    || (data?.dataZone === DataZone.SECURE && this.permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII] && this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII])
    || (data?.dataZone === DataZone.LIVE && this.permissionsMap[PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE] && this.permissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE]));
  }

  openActivityDetails(instanceData: any): void {
    const data = { 
      activityDetail: instanceData?.activityDetails, 
      instance: instanceData 
    };
    this.sidenavService.openInRightSidenav(EnvironmentActivityDetails, data, "activityDetails")
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((detail) => {
      const arrays = [{ data: this.classEInstances, update: (data: any[]) => this.classEInstances = data},
      { data: this.devInstance, update: (data: any[]) => this.devInstance = data},
      { data: this.testDataZoneInstances, update: (data: any[]) => this.testDataZoneInstances = data},
      { data: this.piiDataZoneInstances, update: (data: any[]) => this.piiDataZoneInstances = data},
      { data: this.otherInstance, update: (data: any[]) => this.otherInstance = data}];
      const matchedArray = arrays.find(group => group.data?.some(item => item.id === detail?.instanceId));
      if (!matchedArray) {return;}
      const updatedArray = this.activityProgressService.updateInstanceActivityDetail(matchedArray.data,detail);
      matchedArray.update(updatedArray);
    });
  }

  private loadInstanceActivity(instances: any[]): void {
    instances?.forEach((item) => {
      if (this.inProgressStatus.includes(item.status) && item.status !== DeployStatus.TERMINATED) {
        this.activityService.getInstanceActivityLogs(item.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((activityLogs) => {
            const logs = Array.isArray(activityLogs) ? activityLogs : (activityLogs?.data ?? []);
            const latestLog = [...logs].sort((a, b) =>
              new Date(b?.startTime).getTime() - new Date(a?.startTime).getTime())[0];

            this.activityService.getInstanceActivityLogsById(item.id, latestLog?.id)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((activityLogs) => {
                item.activityDetails = activityLogs;
                const stages: any[] = activityLogs?.stages ?? [];
                const execStage = stages.find(s => s.type === 'component_execution');
                item.activityDetails.countData = {};
                if (execStage?.count?.total) {
                  const total = Number(execStage.count.total);
                  const completed = Number(execStage.count.completed ?? 0);
                  const skipped = Number(execStage.count.skipped ?? 0);
                  item.activityDetails.countData.total = total;
                  item.activityDetails.countData.completedPercent =
                    completed !== 0 ? Math.round(((completed + skipped) / total) * 100) : 0;
                }
              });
              item.activityStartTime = latestLog.startTime;
              item.expectedDurationMs = latestLog.expectedDurationMs;
              if (latestLog?.count && latestLog?.count?.total) {
                item.total = Number(latestLog.count.total);
                item.completed = Number(latestLog.count.completed ?? 0);
                item.skipped = Number(latestLog.count.skipped ?? 0);
                item.pending = Number(item.total - (item.completed + item.skipped));
                item.completedPercent = item?.completed !== 0 ? Math.round(((item?.completed + item?.skipped) / item.total) * 100) : 0;
              }
          });
      }
    });
  }

  onInstanceMenuOpened(): void {
    handleInstanceMenuPositioning();
  }
}